export default __webpack_public_path__ + "static/media/White0000.3b63a8f1.png";